import isMobile from "../../plugins/is-mobile.js";

if (isMobile(414)) {
  $(window)
    .on("resize", function() {
      var h = $(window).height();

      $(".top-hero").css({
        height: h + "px"
      });
    })
    .trigger("resize");
}
